exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_object-pie.js
// module id = 19
// module chunks = 0 1